import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { BusinessActivitiesReportTable } from "./BusinessActivitiesReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { BusinessActivitiesReportFilter } from "./BusinessActivitiesReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const BusinessActivitiesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchBusinessActivities" />}
              action={<BusinessActivitiesReportActions />}
            />
            <Divider />
            <CardContent>
              <BusinessActivitiesReportTable
                userAccessRights={userAccessRights}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const BusinessActivitiesReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <BusinessActivitiesReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default BusinessActivitiesReport;
